import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import Maps from "views/examples/Maps.js";

import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import DicomConverter from "./views/examples/DicomConverter";
import MeshConverter from "./views/examples/MeshConverter";
import FileManager from "./views/examples/UserFiles";

var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <Index />,
    layout: "/cabinet",
  },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   icon: "ni ni-planet text-blue",
  //   component: <Icons />,
  //   layout: "/test_react/admin",
  // },
  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   icon: "ni ni-single-02 text-yellow",
  //   component: <Profile />,
  //   layout: "/test_react/admin",
  // },
  // {
  //   path: "/tables",
  //   name: "Tables",
  //   icon: "ni ni-bullet-list-67 text-red",
  //   component: <Tables />,
  //   layout: "/test_react/admin",
  // },
  {
    path: "/file-converter",
    name: "DICOM converter",
    icon: "ni ni-circle-08 text-pink",
    component: <DicomConverter />,
    layout: "/cabinet",
  },
  {
    path: "/mesh-converter",
    name: "MESH converter",
    icon: "ni ni-circle-08 text-pink",
    component: <MeshConverter />,
    layout: "/cabinet",
  },
  {
    path: "/files",
    name: "Files",
    icon: "ni ni-circle-08 text-pink",
    component: <FileManager />,
    layout: "/cabinet",
  },
];
export default routes;
